import { RootState } from '@/models/root-state.model';
import { IpDataModel } from '@/models/ip-data.model';
import { RegionCheckResponse } from '@/models/region-check.model';
import { WrapperPlatform } from '@/models/enum/wrapper-platform.enum';
import { createSelector } from 'reselect';
import { parseAffiliateId } from '@/utils/logic.utils';
import { OntarioLocationCheckStatus } from '@/models/enum/ontario-location-check-status.enum';
import { envIsCanada, envIsNormal, envIsSweden } from '@/constants/constants';

export const selectLocale = (state: RootState): string => state.common.locale;
export const selectFitToPlay = (state: RootState): boolean => state.common.fitToPlay;
export const selectIpData = (state: RootState): IpDataModel => state.common.ipData;
export const selectOntarioCanPlay = (state: RootState): boolean => state.common.ontarioCanPlay;
export const selectDetectedRegion = (state: RootState): RegionCheckResponse =>
  state.common.detectedRegion;
export const selectBtag = (state: RootState): string => state.common.btag;
export const selectOntarioLocationCheckStatus = (state: RootState): OntarioLocationCheckStatus =>
  state.common.ontarioLocationCheckStatus;
export const selectOntarioLocationCheckError = (state: RootState): string | undefined =>
  state.common.ontarioLocationCheckError;
export const selectBtagPrefix = createSelector(selectBtag, btag => {
  const parsedAffiliateId = parseAffiliateId(btag);
  return parsedAffiliateId !== undefined ? parsedAffiliateId.btag : undefined;
});

export const selectWrapperPlatform = (state: RootState): WrapperPlatform => state.common.platform;

export const selectIsInAppWrapper = createSelector(
  selectWrapperPlatform,
  platform => platform !== WrapperPlatform.None,
);

export const selectIsThailand = createSelector(selectLocale, locale => locale === 'th');
export const selectIsROC = createSelector(
  selectLocale,
  locale => envIsNormal() && ['ca', 'ca-fr'].includes(locale),
);
export const selectIsCanadaMarket = createSelector(selectIsROC, isROC => envIsCanada() || isROC);
export const selectIsFinOrSv = createSelector(
  selectLocale,
  locale => ['fi', 'fi-en'].includes(locale) || envIsSweden(),
);
export const selectIsFin = createSelector(selectLocale, locale => ['fi', 'fi-en'].includes(locale));
